import queryString from "query-string";

/**
 * Query-string encoding shared by every surface that keeps state in the URL.
 *
 * Arrays serialise as repeated keys -- `tools=a&tools=b`, never `tools[]=a` -- because DRF
 * reads them with `getlist` and the bracket form arrives as a single key it does not know.
 * `api.agent.js` serialises its own request params the same way, for the same reason.
 */

export const toSearch = (params = {}) => {
    const search = queryString.stringify(params, { arrayFormat: "none", skipNull: true, skipEmptyString: true });
    return search ? `?${search}` : "";
};

export const parseSearch = (search = "") => queryString.parse(search, { arrayFormat: "none" });
